<template>
    <div class="mt-8 w-full h-full bg-white">
      <SuppliersGroup
        v-loading="loading"
        element-loading-text="Loading..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"/>
    </div>
  </template>

<script>

import SuppliersGroup from './components/SuppliersGroup.vue';

export default {
  name: 'SuppliersGroupView',
  components: {
    SuppliersGroup,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async fetchGroups() {
      try {
        await this.$store.dispatch('InventoryModule/SuppliersGroup/fetchAllSuppliersGroups');
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
    },
  },
  mounted() {
    this.loading = true;
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    this.fetchGroups();
    this.loading = false;
  },
};
</script>

<style scoped></style>
